export default {
    getItem(key, def) {
        const value = window.localStorage.getItem(key);
        return value === null || value === 'null' ? def : value;
    },
    setItem(key, value) {
        window.localStorage.setItem(key, value);
    }
}